import gql from 'graphql-tag'
import { VideosTable_video } from './videos/components/VideosTable.fragments'

const VIDEOS_QUERY = gql`
  query VideosQuery {
    viewer {
      id
      videos(first: 100) {
        edges {
          node {
            __typename
            ...VideosTable_video
          }
        }
      }
    }
  }
  ${VideosTable_video}
`
export default VIDEOS_QUERY



// WEBPACK FOOTER //
// ./src/routes/videos.query.js